import http from "./http-common";

export const getCapabilities = ({ queryKey }) => {
  const search = queryKey.length > 1 ? queryKey[1].partNumber : null;

  let url = "/capability/search";
  if (search) url += `?partNumbers=${search}`;
  return http.get(url);
};
